import { API_BASE_URL } from '../../config';
import {
  ApiEndpoint,
  ApiInterface,
  BaseAxiosClient
} from '../../interface_adapters/clients/BaseAxiosClient';

/**
 * AcquisitionClient class extends AbstractApiClient and implements ApiInterface.
 * This class is responsible for making API requests related to Leads and orders.
 * It also handles the confirmation of these.
 *
 * @extends {BaseAxiosClient}
 * @implements {ApiInterface}
 */
class AcquisitionClient extends BaseAxiosClient implements ApiInterface {
  static baseURL: string = API_BASE_URL;
  apiEndpoints: ApiEndpoint = {
    Orders: '/api/orders',
    Leads: '/api/leads',
    EMailConfirmation: '/confirm/email'
  };

  constructor() {
    super(AcquisitionClient.baseURL);
  }

  /**
   * Public method to confirm the email address of a lead or an order.
   *
   * @param {string} id - The id of the lead or order
   * @param {string} type - The type if the object to confirm is a lead or an order
   * @param {string} key - The access key to authenticate us in the backend
   * @returns {Promise<Object>} A Promise resolving to the response data.
   */
  confirmEmailById(id: string, type: string, key: string): Promise<{}> {
    const path = this.getPathByType(type);
    const completeUrl = `${path}/${id}${this.apiEndpoints.EMailConfirmation}`;
    return this.get(completeUrl, { key: key });
  }

  private getPathByType(type: string): string {
    return type === 'order' ? this.apiEndpoints.Orders : this.apiEndpoints.Leads;
  }
}

export { AcquisitionClient };
